import { EventSourcePolyfill } from "event-source-polyfill";
import { useEffect, useState } from "react";
import { DataMode } from "../context/ConnectionContext";
import { CompletePitchData } from "../types/StrikeZone";

export const usePitchDataSse = (mode?: DataMode, venueGuid?: string): [boolean, CompletePitchData] => {
  const [connected, setConnected] = useState(false);
  const [data, setData] = useState<CompletePitchData>();

  useEffect(() => {
    if (mode === "sse" && !!venueGuid) {
      const url = `${process.env.SSE_URL}/sse/register?channel=abs-scoreboard-${process.env.ENV}.data.${venueGuid}`;
      const sse = new EventSourcePolyfill(url, {
        headers: {
          "sse-auth": venueGuid,
        },
        lastEventIdQueryParameterName: "none",
      });

      sse.onmessage = (ev) => {
        setData(JSON.parse(ev.data));
      };

      sse.onopen = () => {
        setConnected(true);
      };

      sse.onerror = () => {
        setConnected(false);
      };

      return () => sse.close();
    }
  }, [mode, venueGuid]);
  return [connected, data];
};
